// 平行链的浏览器 只需要部分功能
const btyLogo = require('@/assets/images/img/BTY1.png')

const fullFeaturedConfig = {
  btns: {
    index: true, //首页
    nodes: true, //节点
    pushtx: true, //广播交易
    block: true, //区块
    token: true //Token币
  },
  brandName: 'BitYuan',
  logo: btyLogo // logo
}

const simplestConfig = {
  btns: {
    index: true,
    pushtx: true,
    block: true,
    token: true
  },
  brandName: '',
  logo: btyLogo
}

let config = fullFeaturedConfig

if (process.env.VUE_APP_IS_TIDY === 'true') {
  config = simplestConfig
}

if (process.env.VUE_APP_LOGO_URL) {
  config.logo = process.env.VUE_APP_LOGO_URL
}

if (process.env.VUE_APP_BRAND_NAME) {
  config.brandName = process.env.VUE_APP_BRAND_NAME
}

export default config